<template>
  <v-container>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h2
          class="primary--text"
        >
          Edit Ballet Class
        </h2>
        <v-dialog
          v-model="dialog"
          width="500"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="red"
              dark
              v-bind="attrs"
              v-on="on"
            >
              - Delete class
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Are you sure?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p>Are you sure you'd like to delete this class?</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="deleteClass()"
              >
                Yes, Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex
        xs12
      >
        <form @submit.prevent="onUpdateBalletClass">
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-text-field
                id="title"
                v-model="title"
                name="title"
                label="Title"
                required
              />
              <v-text-field
                id="ballet-class-description"
                v-model="balletClassDescription"
                item-value="db"
                name="balletClassDescription"
                label="Description / Details"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <h3>
                Choose a Date
              </h3>
            </v-flex>
          </v-layout>
          <v-layout
            row
            pt-3
          >
            <v-flex
              offset-sm3
            >
              <v-date-picker
                v-model="date"
                required
              />
            </v-flex>
          </v-layout>
          <v-row
            justify="space-around"
            align="center"
          >
            <v-col style="width: 350px; flex: 0 1 auto;">
              <h2>Start:</h2>
              <v-time-picker
                v-model="start"
                required
              ></v-time-picker>
            </v-col>
            <v-col style="width: 350px; flex: 0 1 auto;">
              <h2>End:</h2>
              <v-time-picker
                v-model="end"
                required
              ></v-time-picker>
            </v-col>
          </v-row>
          <v-layout
            row
            pt-5
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-btn
                class="primary"
                :disabled="!formIsValid"
                type="submit"
              >
                Update Class
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  const moment = require('moment')
  export default {
    props: ['id'],
    data () {
      return {
        dialog: false,
        title: '',
        balletClassDescription: '',
        date: '',
        start: '',
        end: ''
      }
    },
    computed: {
      currentBalletClass () {
        return this.$store.getters.currentBalletClass
      },
      formIsValid () {
        return this.title !== '' && this.start !== '' && this.end !== ''
      }
    },
    created () {
      this.$store.dispatch('loadBalletClass', this.id).then(() => {
        this.title = this.currentBalletClass.title
        this.balletClassDescription = this.currentBalletClass.description
        this.date = moment(this.currentBalletClass.startDate.toDate()).format('YYYY-MM-DD')
        this.start = moment(this.currentBalletClass.startDate.toDate()).format('HH:mm')
        this.end = moment(this.currentBalletClass.endDate.toDate()).format('HH:mm')
      })
    },
    methods: {
      deleteClass () {
        this.$store.dispatch('deleteBalletClass', this.id)
        this.$router.push('/ballet-classes')
      },
      onUpdateBalletClass () {
        if (!this.formIsValid) {
          return
        }
        var startTime = moment(this.date).set({
          hour: this.start.match(/(\d+):(\d+)/)[1],
          minute: this.start.match(/(\d+):(\d+)/)[2]
        }).toDate()
        var endTime = moment(this.date).set({
          hour: this.end.match(/(\d+):(\d+)/)[1],
          minute: this.end.match(/(\d+):(\d+)/)[2]
        }).toDate()
        const balletClassData = {
          id: this.id,
          title: this.title,
          description: this.balletClassDescription,
          startDate: startTime,
          endDate: endTime
        }
        console.log(balletClassData)
        this.$store.dispatch('updateBalletClass', balletClassData)
        this.$router.push('/ballet-classes')
      }
    }
  }
</script>
